export function enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
    return Object.keys(obj).filter((k) => !Number.isNaN(k)) as K[]
}

export const mapEnumValueByKey = <T extends Record<keyof U, unknown>, U extends Record<keyof T, unknown>>(
    valueSrc: T[keyof T],
    enumSrc: T,
    enumDst: U,
): U[keyof U] => {
    const entry = Object.entries(enumSrc).find(([, v]) => v === valueSrc)
    if (!entry) {
        throw new Error(`Value ${valueSrc} not found in source enum`)
    }
    const [key] = entry
    const dstValue = enumDst[key as keyof U]
    if (dstValue === undefined) {
        throw new Error(`Key ${key} not found in destination enum`)
    }
    return dstValue
}
